<template>
  <div>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="600"
      v-model="dialog"
      persistent
      content-class="complement-form"
    >
      <v-card>
        <v-form @submit.prevent="validate()">
          <!-- <v-card-title class="headline">Finalize seu cadastro</v-card-title> -->

          <v-card-text class="pb-0">
            <v-container>
              <!-- <v-row>
                <v-col cols="12" md="5" class="pb-0">
                  <v-text-field
                    dense
                    outlined
                    disabled
                    type="text"
                    label="Nome"
                    v-model="name"
                  />
                </v-col>
                <v-col cols="12" md="7" class="pb-0">
                  <v-text-field
                    dense
                    outlined
                    disabled
                    type="text"
                    label="Sobrenome"
                    v-model="lastname"
                  />
                </v-col>
                <v-col cols="12" md="4" class="pb-0">
                  <v-text-field
                    dense
                    outlined
                    disabled
                    type="text"
                    label="Telefone"
                    v-model="tel"
                  />
                </v-col>
                <v-col cols="12" md="4" class="pb-0">
                  <v-text-field
                    dense
                    outlined
                    type="text"
                    label="CPF"
                    v-model="cpf"
                    disabled
                  />
                </v-col>
                <v-col cols="12" md="4" class="pb-0">
                  <v-text-field
                    dense
                    outlined
                    type="text"
                    label="CRM"
                    v-model="crm"
                    disabled
                  />
                </v-col>
                <v-col cols="12" class="pb-0">
                  <v-text-field
                    dense
                    outlined
                    type="email"
                    label="Email"
                    disabled
                    v-model="email"
                  />
                </v-col>

              </v-row> -->
              <v-row>
                <!-- <v-col cols="10" class="mx-auto">
                  <v-divider></v-divider>
                </v-col> -->
                <v-col cols="12" class="txt2">
                  <h3 class="">Finalize seu cadastro</h3>
                  <p style="font-size: .6rem;">Preencha os campos abaixo com seus dados restantes:</p>
                </v-col>
                <v-col cols="12" md="5" class="pt-4 pt-md-0 pb-0">
                  <v-text-field
                    dense
                    outlined
                    color="green"
                    type="text"
                    label="Especialidade"
                    v-model="especialidade"
                  />
                </v-col>
                <v-col cols="12" md="3" class="py-0">
                  <v-select
                    :items="estados"
                    label="Estado"
                    outlined
                    color="green"
                    dense
                    v-model="estado"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4" class="py-0">
                  <v-menu
                    outlined
                    color="green"
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        dense
                        outlined
                        color="green"
                        v-model="chosenBirthday"
                        label="Data de nascimento"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :max="maioridade"
                      :show-current="maioridade"
                      locale="pt-br"
                      v-model="chosenBirthday"
                      @change="updateBirthday"
                      @input="menu = false"
                      color="green"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="pt-0">
                  <small>Sexo:</small>
                  <v-radio-group v-model="sexo" row dense class="mt-0">
                    <v-radio
                      color="green"
                      label="Masculino"
                      value="masculino"
                    ></v-radio>
                    <v-radio
                      color="green"
                      label="Feminino"
                      value="feminino"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row class="py-0">
                <v-col cols="12" class="py-0">
                  <v-checkbox
                    v-model="checkbox"
                    class="txt2 optout"
                    color="green"
                    dense
                    label="Autorizo o CMF compartilhar informações relevantes com o patrocinador desse curso"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-btn
                  x-large
                  block
                  depressed
                  color="btn-primary"
                  type="submit"
                >
                  Finalizar cadastro
                </v-btn>
              </v-row>
              <v-row>
                <v-btn
                  class="px-8 mt-4"
                  color="green"
                  text
                  x-large
                  block
                  @click="logout(), dialog = false"
                >Agora não</v-btn>
              </v-row>
            </v-container>
          </v-card-text>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- THANK YOU DIALOG -->
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="500"
      v-model="confirmDialog"
    >
      <v-card  class="pt-10">
        <v-img
          alt="Plataforma de Curso de Cannabis Medicinal para Reumatologistas"
          contain
          src="../../assets/check.svg"
          max-height="300px"
          position="center center"
        ></v-img>
        <v-card-text class="px-12 pb-0 mt-8 text-center">
          <h2 class="title-comp mb-4">Prontinho!</h2>
          <p>Seu cadastro foi finalizado com sucesso, aproveite o 1º Curso de Cannabis Medicinal para Reumatologistas.</p>
        </v-card-text>
        <v-card-actions class="pb-12 px-12 justify-end">
          <v-btn
            color="btn-primary"
            depressed
            x-large
            block
            @click="confirmDialog = false"
          >Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ------- SNACKBAR FEEDBACK -------- -->
    <v-snackbar v-if="feedback" :color="feedback.color" :class="feedback.textColor" v-model="feedback.show">
      {{feedback.message}}
      <v-btn :class="feedback.textColor" outlined @click="feedback.show = false" v-if="feedback.btnTxt">
        {{feedback.btnTxt}}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import moment from 'moment'
import firebase from 'firebase'
import db from '@/firebase/init.js'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CompForm',
  // props: {
  //   currentUser: Object
  // },
  data() {
    return {
      id: null,
      showForm: false,
      currentUser: null,
      userData: null,
      dialog: false,
      confirmDialog: false,
      // new registerform
      stepper: 1,
      name: null,
      lastname: null,
      birthday: null,
      chosenBirthday: null,
      sexo: null,
      especialidade: null,
      tel: null,
      crm: null,
      estado: null,
      cpf: null,
      email: null,
      checkbox: true,
      menu: false,
      maioridade: moment(Date.now() - 569648000000).format('YYYY-MM-DD'),
      radio: 'Sexo',
      //feedback
      feedback: {
        show: false,
        message: '',
        btnTxt: '',
        color: '',
        textColor: ''
      },
      estados: [
        'AC',
        'AL',
        'AP',
        'AM',
        'BA',
        'CE',
        'ES',
        'GO',
        'MA',
        'MT',
        'MS',
        'MG',
        'PA',
        'PB',
        'PR',
        'PE',
        'PI',
        'RJ',
        'RN',
        'RS',
        'RO',
        'RR',
        'SC',
        'SP',
        'SE',
        'TO',
      ]
    }
  },
  computed: {
    ...mapGetters(['isUserAuth', 'getUser'])
  },
  methods: {
    ...mapActions(['signOutAction', 'updateUserAction']),

    logout() {
      this.signOutAction();
      // firebase.auth().signOut()
      // this.$router.push('/login')
    },
    updateBirthday(){
      this.birthday = moment(this.chosenBirthday).format("DD-MM-YYYY");
    },
    setFeedback(show, message, btnTxt, color, textColor){
      this.feedback = {
        show: show,
        message: message,
        btnTxt: btnTxt,
        color: color,
        textColor: textColor
      }
    },
    resetForm() {
      // this.name = null,
      // this.lastname = null,
      this.birthday = null,
      this.chosenBirthday = null,
      this.sexo = null,
      this.especialidade = null
      // this.email = null,
      // this.crm = null
    },
    validate() {
      if(this.sexo && this.especialidade && this.estado && this.birthday){
        // console.log(
        //   this.name + ", " +
        //   this.lastname + ", " +
        //   this.birthday + ", " +
        //   this.sexo + ", " +
        //   this.especialidade + ", " +
        //   this.email + ", " +
        //   this.crm
        // )
        this.completeRegister()
      } else{
        this.setFeedback(true, 'Todos os campos devem ser preenchidos', 'OK', 'amber', 'black--text')
      }
    },
    completeRegister(){
      // db.collection('usuarios')
      //   .doc(this.id)
      //   .get()
      //   .then(snapshot => {
      //     console.log(snapshot.data())
      //   })
      db.collection('usuarios')
        .doc(this.getUser.email)
        .update({
          // name: this.name,
          // lastname: this.lastname,
          // fullName: this.name + " " + this.lastname,
          dtNasc: this.birthday,
          sexo: this.sexo,
          especialidade: this.especialidade,
          estado: this.estado,
          autorizou: this.checkbox,
          // email: this.email,
          // crm: this.crm,
          dtNewCadastro: moment(Date.now()).format('YYYY-MM-DD'),
          tsNewCadastro: Date.now()
        })
        .then(() => {
          console.log('cadastro atualizado')
          // this.setFeedback(true, 'Seu cadastro foi finalizado. Aproveite o curso!', 'OK', 'green', 'white--text')
          // this.$router.push('/')
          this.updateUserAction({email: this.getUser.email})
          this.dialog = false
          this.confirmDialog = true
        })
        .catch(e => {
          console.log('Ocorreu um erro ao tentar atualizar o cadastro')
          this.setFeedback(true, e.message, 'OK', 'red', 'white--text')
        })
      // firebase
      //   .auth()
      //   .createUserWithEmailAndPassword(this.email, this.password)
      //   .then(cred => {
      //     console.log('criou usuario')
      //     // this.$router.push({ name: 'index' })
      //     db.collection('usuarios').doc(cred.user.uid)
      //     .set({
      //       name: this.name,
      //       lastname: this.lastname,
      //       fullName: this.name + " " + this.lastname,
      //       dtNasc: this.birthday,
      //       sexo: this.sexo,
      //       especialidade: this.especialidade,
      //       email: this.email,
      //       crm: this.crm,
      //       dtCadastro: moment(Date.now()).format('YYYY-MM-DD'),
      //       tsCadastro: Date.now()
      //     }).then(() => {
      //       console.log('adicionou ao banco')
      //       this.$router.push('/')
      //     })
      //   })
      //   .catch(err => {
      //     // console.log('deu erro' + err.message)
      //     // window.console.log(err)
      //     this.setFeedback(true, err.message, 'OK', 'red', 'white--text')
      //     // this.error = true
      //   })
    },
  },
  mounted() {
    this.currentUser = this.getUser
    // console.log(this.getUser)

    // this.currentUser.sexo ? this.dialog = false : this.dialog = true

    this.name = this.currentUser.nome
    this.lastname = this.currentUser.sobrenome
    this.tel = this.currentUser.tel
    this.crm = this.currentUser.crm
    this.cpf = this.currentUser.cpf
    this.email = this.currentUser.email


    // firebase.auth().onAuthStateChanged(user => {
    //   if (user){
    //     this.currentUser = user

    //     db.collection('usuarios')
    //       .where("email", "==", user.email)
    //       .get()
    //       .then(snapshot => {
    //         snapshot.docs.forEach(doc => {
    //           let userData = doc.data()

    //           userData.sexo ? this.dialog = false : this.dialog = true
    //           this.id = doc.id
    //           this.email = userData.email
    //           this.crm = userData.crm
    //         })
    //       })
    //   } else {
    //     this.currentUser = null
    //   }
    // })
  },
}
</script>

<style lang="scss">

.title-comp{
  color: #303030;
  font-size: 2.5em;
  font-weight: 900;;
}
.complement-form{
  &.v-dialog.v-dialog--active.v-dialog--persistent{
    position: relative !important;
  }
}
.optout {
  .v-label {
    font-size: .6rem
  }
}
</style>